export class WorkflowTask{
    workflowId?: Nullable<string>;
    taskLabel?: Nullable<string>;
    taskTypeId?: Nullable<number>;
    statusId?: Nullable<number>;

    constructor(){
        this.workflowId = null;
        this.taskLabel = null;
        this.taskTypeId = null;
        this.statusId = null;
    }
}